import { findArray } from 'helpers/utils';
import Label from 'components/general/Label';
import { ColumnNameH2H } from "components/common/TableColumns"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";

const asterisc = "*";

export function ColumnBibRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Bib',
    headerClassName: "text-end w-5 text-nowrap align-middle",
    id: 'HeaderBib',
    columns: [
      ColumnBib({})
    ]
  }
}

export function ColumnBib({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-5 text-nowrap',
  remove = true,
  accessor = "bib"
}) {
  return (
    {
      Header: <Label data="HeaderNumber" />,
      accessor: accessor,
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Bib',
      remove: remove,
      Cell: (props) => {
        const row = props.cell.row.original
        let isSuspended = findArray(row?.eventUnitEntries, { eue_code: ['STATUS'] }).eue_value === 'SUSPEND';
        let starter = findArray(row?.eventUnitEntries, { eue_code: ['STARTER'] }) ? asterisc : '';

        return isSuspended ? <>(S)</> : row.bib > 99999 ? <></> : <>{starter}{row.bib}</>;
      }
    }
  )
}

export function ColumnNameRowSpan({ label = "HeaderName" }) {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Name',
    headerClassName: "text-start w-20 align-middle",
    id: 'HeaderName',
    columns: [
      ColumnNameH2H({ remove: true, label: label, hideNoc: true })
    ]
  }
}

export function ColumnMinsRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Mins',
    headerClassName: "text-end w-5 align-middle",
    id: 'HeaderMins',
    columns: [
      ColumnMins({})
    ]
  }
}

function ColumnMins() {
  return {
    id: 'Mins',
    Header: <Label data="HeaderTimePlayed" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: true,
    Cell: (props) => {
      let value = findArray(props.cell.row.original.statsItems, { code: ['MINS'] }).value;
      return (
        <Value value={value} />
      )
    }
  }
}

export function ColumnGoalShotsColSpan() {
  return {
    id: 'HeaderGoalsShots',
    Header: <Label data="HeaderGoalsShots" />,
    headerClassName: "text-center",
    columns: [
      ColumnTotal({}),
      ColumnPercent({}),
      ColumnActionShot({}),
      ColumnCentreShot({}),
      ColumnDriveShot({}),
      ColumnExtraPlayerShot({}),
      Column6mShots({}),
      ColumnPenaltyShot({}),
      ColumnCounterAttackShots({})
    ]
  }
}

function ColumnTotal() {
  return {
    id: 'Total',
    Header: <Label data="HeaderTotal" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 1,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'TOTAL')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnPercent() {
  return {
    id: 'Percent',
    Header: <Label data="HeaderPercent" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 2,
    Cell: (props) => {
      const { percent } = getStatValues(props, 'TOTAL')
      return (
        <Value value={percent} />
      )
    }
  }
}

function ColumnActionShot() {
  return {
    id: 'ActionShot',
    Header: <Label data="HeaderActionShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 3,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'ACT')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnCentreShot() {
  return {
    id: 'CentreShot',
    Header: <Label data="HeaderCentreShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 4,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'CNT')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnDriveShot() {
  return {
    id: 'DriveShot',
    Header: <Label data="HeaderDriveShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 5,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'DRV')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnExtraPlayerShot() {
  return {
    id: 'ExtraPlateyShot',
    Header: <Label data="HeaderExtraPlayerShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 6,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'EXT')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function Column6mShots() {
  return {
    id: 'Shots6m',
    Header: <Label data="Header6mShots" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 7,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, '6M')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnPenaltyShot() {
  return {
    id: 'PenaltyShot',
    Header: <Label data="HeaderPenaltyShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 8,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'PTY')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnCounterAttackShots() {
  return {
    id: 'CounterAttackShots',
    Header: <Label data="HeaderCounterAttackShots" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 9,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'CAT')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

export function ColumnTurnoversFoulsRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'TurnoversFouls',
    headerClassName: "text-end align-middle",
    id: 'HeaderTurnoversFouls',
    columns: [
      ColumnTurnoversFouls({})
    ]
  }
}

function ColumnTurnoversFouls() {
  return {
    id: 'TurnoversFouls',
    Header: <Label data="HeaderTurnoversFouls" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: true,
    isVisible: false,
    columnIndex: 10,
    Cell: (props) => {
      const { value } = getStatValues(props, 'TFL')
      return (
        <Value value={value} />
      )
    }
  }
}

export function ColumnStealsRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Steals',
    headerClassName: "text-end align-middle",
    id: 'HeaderSteals',
    columns: [
      ColumnSteals({})
    ]
  }
}

function ColumnSteals() {
  return {
    id: 'Steals',
    Header: <Label data="HeaderSteals" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: true,
    isVisible: false,
    columnIndex: 11,
    Cell: (props) => {
      const { value } = getStatValues(props, 'ST')
      return (
        <Value value={value} />
      )
    }
  }
}

export function ColumnReboundsRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Rebounds',
    headerClassName: "text-end align-middle",
    id: 'HeaderRebounds',
    columns: [
      ColumnRebounds({})
    ]
  }
}

function ColumnRebounds() {
  return {
    id: 'Rebounds',
    Header: <Label data="HeaderRebounds" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: true,
    isVisible: false,
    columnIndex: 12,
    Cell: (props) => {
      const { value } = getStatValues(props, 'REB')
      return (
        <Value value={value} />
      )
    }
  }
}

export function ColumnBlockedShotsRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'BlockedShots',
    headerClassName: "text-end align-middle",
    id: 'HeaderBlockedShots',
    columns: [
      ColumnBlockedShots({})
    ]
  }
}

function ColumnBlockedShots() {
  return {
    id: 'BlockedShots',
    Header: <Label data="HeaderBlockedShots" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: true,
    isVisible: false,
    columnIndex: 13,
    Cell: (props) => {
      const { value } = getStatValues(props, 'BLC')
      return (
        <Value value={value} />
      )
    }
  }
}

export function ColumnSprintsRowSpan() {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Sprints',
    headerClassName: "text-end align-middle",
    id: 'HeaderSprints',
    columns: [
      ColumnSprints({})
    ]
  }
}

function ColumnSprints() {
  return {
    id: 'Sprints',
    Header: <Label data="HeaderSprints" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: true,
    isVisible: false,
    columnIndex: 14,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'SP')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

export function ColumnPersonalFoulsColSpan() {
  return {
    id: 'HeaderPersonalFouls',
    Header: <Label data="HeaderPersonalFoulsDesc" />,
    headerClassName: "text-center",
    columns: [
      ColumnCentreForwardExclusion({}),
      ColumnFieldExclusion({}),
      ColumnDrivingExclusion({}),
      Column6MetreExclusion({}),
      ColumnCounterAttackExclusion({}),
      ColumnDoubleExclusion({}),
      ColumnPenaltyFoul({}),
      ColumnExclusion({})
    ]
  }
}

function ColumnCentreForwardExclusion() {
  return {
    id: 'CentreForwardExclusion',
    Header: <Label data="HeaderCentreForwardExclusion" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: false,
    columnIndex: 15,
    Cell: (props) => {
      const { value } = getStatValues(props, 'TYC')
      return (
        <Value value={value} />
      )
    }
  }
}

function ColumnFieldExclusion() {
  return {
    id: 'FieldExclusion',
    Header: <Label data="HeaderFieldExclusion" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: false,
    columnIndex: 16,
    Cell: (props) => {
      const { value } = getStatValues(props, 'TYF')
      return (
        <Value value={value} />
      )
    }
  }
}

function ColumnDrivingExclusion() {
  return {
    id: 'DrivingExclusion',
    Header: <Label data="HeaderDrivingExclusion" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: false,
    columnIndex: 17,
    Cell: (props) => {
      const { value } = getStatValues(props, 'DS')
      return (
        <Value value={value} />
      )
    }
  }
}

function Column6MetreExclusion() {
  return {
    id: '6MetreExclusion',
    Header: <Label data="Header6MetreExclusion" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: false,
    columnIndex: 18,
    Cell: (props) => {
      const { value } = getStatValues(props, 'M6')
      return (
        <Value value={value} />
      )
    }
  }
}

function ColumnCounterAttackExclusion() {
  return {
    id: 'CounterAttackExclusion',
    Header: <Label data="HeaderCounterAttackExclusion" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: false,
    columnIndex: 19,
    Cell: (props) => {
      const { value } = getStatValues(props, 'CS')
      return (
        <Value value={value} />
      )
    }
  }
}

function ColumnDoubleExclusion() {
  return {
    id: 'DoubleExclusion',
    Header: <Label data="HeaderDoubleExclusion" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: false,
    columnIndex: 20,
    Cell: (props) => {
      const { value } = getStatValues(props, '2EXC')
      return (
        <Value value={value} />
      )
    }
  }
}

function ColumnPenaltyFoul() {
  return {
    id: 'PenaltyFoul',
    Header: <Label data="HeaderPenaltyFoul" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: false,
    columnIndex: 21,
    Cell: (props) => {
      const { value } = getStatValues(props, 'FRP')
      return (
        <Value value={value} />
      )
    }
  }
}

function ColumnExclusion() {
  return {
    id: 'Exclusion',
    Header: <Label data="HeaderExclusion" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: false,
    columnIndex: 22,
    Cell: (props) => {
      const { value } = getStatValues(props, 'EXC')
      return (
        <Value value={value} />
      )
    }
  }
}

export function ColumnSavesShotsColSpan({ isMobile }) {
  return {
    id: 'SavesShots',
    Header: <Label data="HeaderSavesShots" />,
    headerClassName: "text-center w-75",
    columns: [
      ColumnsTotalGk({ isVisible: !isMobile }),
      ColumnsEfficiencyGk({ isVisible: !isMobile }),
      ColumnsActionShotGk({ isVisible: !isMobile }),
      ColumnsCentreShotGk({ isVisible: !isMobile }),
      ColumnsDriveShotGk({ isVisible: !isMobile }),
      ColumnsExtraPlayerShotsGk({ isVisible: !isMobile }),
      Columns6mShotsGk({ isVisible: !isMobile }),
      ColumnsPenaltyShotsGk({ isVisible: !isMobile }),
      ColumnsCounterAttackShotGk({ isVisible: !isMobile })
    ]
  }
}
function ColumnsTotalGk({ isVisible = false }) {
  return {
    id: 'TotalGk',
    Header: <Label data="HeaderTotal" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 1,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'TOTAL_GK')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnsEfficiencyGk({ isVisible = false }) {
  return {
    id: 'EfficiencyGk',
    Header: <Label data="HeaderPercent" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 2,
    Cell: (props) => {
      const { percent } = getStatValues(props, 'TOTAL_GK')
      return (
        <Value value={percent} />
      )
    }
  }
}

function ColumnsActionShotGk({ isVisible = false }) {
  return {
    id: 'Sprints',
    Header: <Label data="HeaderActionShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 3,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'ACT_GK')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnsCentreShotGk({ isVisible = false }) {
  return {
    id: 'CentreShotGk',
    Header: <Label data="HeaderCentreShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 4,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'CNT_GK')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnsDriveShotGk({ isVisible = false }) {
  return {
    id: 'DriveShotGk',
    Header: <Label data="HeaderDriveShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 5,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'DRV_GK')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnsExtraPlayerShotsGk({ isVisible = false }) {
  return {
    id: 'ExtraPlayerShotsGk',
    Header: <Label data="HeaderExtraPlayerShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 6,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'EXT_GK')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function Columns6mShotsGk({ isVisible = false }) {
  return {
    id: '6mShotsGk',
    Header: <Label data="Header6mShots" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 7,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, '6M_GK')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnsPenaltyShotsGk({ isVisible = false }) {
  return {
    id: 'PenaltyShotsGk',
    Header: <Label data="HeaderPenaltyShot" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 8,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'PTY_GK')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function ColumnsCounterAttackShotGk({ isVisible = false }) {
  return {
    id: 'CounterAttackShotGk',
    Header: <Label data="HeaderCounterAttackShots" />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    remove: false,
    isVisible: isVisible,
    columnIndex: 9,
    Cell: (props) => {
      const { value, attempt } = getStatValues(props, 'CAT_GK')
      return (
        <Fraction numerator={value} denominator={attempt} />
      )
    }
  }
}

function Fraction({ numerator, denominator }) {
  return numerator || denominator ? <>{numerator || '-'}/{denominator || '-'}</> : <>-</>;
}

function Value({ value }) {
  return <>{value || '-'}</>;
}

function getStatValues(props, stat) {
  const statItem = findArray(props.cell.row.original.statsItems, { code: [stat] });
  return {
    value: statItem?.value,
    attempt: statItem?.attempt,
    percent: statItem?.percent
  }
}
